import { Route, Routes } from "react-router-dom";

import { AppProvidersLayout } from "src/core/AppProvidersLayout";
import { AuthGate } from "src/core/authentication/AuthGate";
import { RoleGuard } from "src/core/authentication/RoleGuard";
import { TenantParamGuard } from "src/core/authentication/TenantParamGuard";
import { TenantsValidationGate } from "src/core/authentication/TenantsValidationGate";
import { Roles } from "src/core/constants/roles";
import { ROUTE_PATH } from "src/core/constants/routePath";
import { Error403 } from "src/core/pages/Error403";
import { Error404 } from "src/core/pages/Error404";
import { Error500 } from "src/core/pages/Error500";
import { ErrorLayout } from "src/core/pages/ErrorLayout";
import { Folder } from "src/core/pages/Folder";
import { Folders } from "src/core/pages/Folders";
import { Home } from "src/core/pages/Home";
import { Import } from "src/core/pages/Import";
import { Layout } from "src/core/pages/Layout";
import { RootRedirect } from "src/core/RootRedirect";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<AuthGate />}>
        <Route element={<TenantsValidationGate />}>
          {/* Root "/" => redirection vers le tenant par défaut */}
          <Route path="/" element={<RootRedirect />} />

          {/* Routes tenant-scoped */}
          <Route element={<TenantParamGuard />}>
            {/* Erreurs tenant-scoped hors providers GraphQL */}
            <Route path={`${ROUTE_PATH.TENANT_ROOT}/error`} element={<ErrorLayout />}>
              <Route path="403" element={<Error403 />} />
              <Route path="404" element={<Error404 />} />
              <Route path="500" element={<Error500 />} />
              <Route path="*" element={<Error404 />} />
            </Route>

            {/* App */}
            <Route element={<AppProvidersLayout />}>
              <Route path={ROUTE_PATH.TENANT_ROOT} element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="folders" element={<Folders />} />
                <Route path="folders/:id" element={<Folder />} />
                <Route
                  element={
                    <RoleGuard allowedRoles={[Roles.ADMINISTRATEUR]} unauthorizedRedirect="home" />
                  }
                >
                  <Route path="import" element={<Import />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>

      {/* Routes d'erreur globales */}
      <Route element={<ErrorLayout />}>
        <Route path={ROUTE_PATH.ERROR_403} element={<Error403 />} />
        <Route path={ROUTE_PATH.ERROR_404} element={<Error404 />} />
        <Route path={ROUTE_PATH.ERROR_500} element={<Error500 />} />
        <Route path="*" element={<Error404 />} />
      </Route>
    </Routes>
  );
};
